import { TYPES } from '../../types';

const mainReducer = (state, action) => {
     console.log("currrric",action)
    switch(action.type){
        case TYPES.GET_CURRICULUM:
            return {
                ...state,
                banner: action.payload.imagen || null,
                description: action.payload.descripcion || null,
                subjects: action.payload.competencias || null,
                evaluation: action.payload.evaluacion || null,
                ibBachelor: action.payload.bachilleratoIb || null,
                activities: action.payload.actividades_inter || null,
                educativeModel: action.payload.modelo_educativo || null,
                profile: action.payload.perfil_egresado || null,
            }
        default:
            return state
    }
}

export default mainReducer;